export default {
    items: [
        {
            name: 'Codelabs',
            url: '/codelabs',
            icon: 'fa fa-code',
        },
        {
            name: 'Settings',
            url: '/iam',
            icon: 'icon-user-following',
            children: [
                {
                    name: 'Manage access',
                    url: '/iam/permission',
                    icon: 'icon-user-follow',
                },
                {
                    name: 'Projects',
                    url: '/iam/projects',
                    icon: 'icon-people',
                },
            ],
        },
    ],
}
